import { render, staticRenderFns } from "./SuggestedSkillsHeader.vue?vue&type=template&id=06fcc77c&scoped=true&"
import script from "./SuggestedSkillsHeader.vue?vue&type=script&lang=js&"
export * from "./SuggestedSkillsHeader.vue?vue&type=script&lang=js&"
import style0 from "./SuggestedSkillsHeader.vue?vue&type=style&index=0&id=06fcc77c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fcc77c",
  null
  
)

export default component.exports